import { Component, Output, EventEmitter, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'file-upload-dlg',
  templateUrl: './file-upload-dlg.component.html',
  styleUrls: ['./file-upload-dlg.component.scss']
})
export class FileUploadDlgComponent {
  files: File[] = [];
  @Input() acceptType?: string;
  @Output() uploading: EventEmitter<any> = new EventEmitter();

  constructor(public activeModal: NgbActiveModal, private toastr: ToastrService) { }

  onSelect(event) {
    for (let file of event.rejectedFiles) {
      if (file.reason == 'type')
        this.toastr.error(`${file.name} is not supported`);
      else
        this.toastr.error(`${file.name} is larger than 30 MB`);
    }
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  save() {
    this.uploading.emit(this.files);
    this.activeModal.close('Save');
  }
}
